export const SUCCESS = 'events/SUCCESS';
export const FAILURE = 'events/FAILURE';
export const IS_LOADING = 'events/IS_LOADING';
export const SET_EVENTS = 'events/SET_EVENTS';

export const success = results => ({
  type: SUCCESS,
  results
});

export const failure = error => ({
  type: FAILURE,
  error
});

export const isLoading = loading => ({
  type: IS_LOADING,
  loading
});

export const setEvents = events => ({
  type: SET_EVENTS,
  events
});
